import React from 'react'
import PropTypes from 'prop-types'

export default function JobActionButton ({ status, disabled, onSubmit }) {
  return (
    <div>
      {(() => {
        if (status === 'open') {
          return (
            <button
              onClick={() => onSubmit('closed')}
              className='btn btn-lg btn-warning pull-right push-down-super-small space-left'
              disabled={disabled}>
              <span className='pull-left'>Close Job</span>
              <i className='material-icons pull-right thumbster-button-icon'>lock</i>
            </button>
          )
        } else if (status === 'closed') {
          return (
            <button
              onClick={() => onSubmit('open')}
              disabled={disabled}
              className='btn btn-lg btn-primary pull-right push-down-super-small space-left'>
              <span className='pull-left'>Open Job</span>
              <i className='material-icons pull-right thumbster-button-icon'>lock_open</i>
            </button>
          )
        }
        return null
      })()}
    </div>
  )
}

JobActionButton.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired
}
